import { render, staticRenderFns } from "./lotto-result.vue?vue&type=template&id=8790c668&scoped=true&"
import script from "./lotto-result.vue?vue&type=script&lang=js&"
export * from "./lotto-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8790c668",
  null
  
)

export default component.exports